/** Class representing a channel subscription error
 *  @extends Error
 */

export default class ChannelSubscriptionError extends Error {
    /**
     * Create a ChannelSubscriptionError
     * @param {string} status
     */
    constructor(status) {
        const errorStatus = `Error occured, HTTP status code: ${status}`;
        super(errorStatus);
    }
}
